import React from 'react'
import { ErrorPageWrapper } from "./ErrorPages/ErrorPageWrapper";
import { LoadingCircleIconAnimated } from "./Icons";
import { useErrorIconSize } from './Icons/ErrorIconSize';

export const LoadingPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    
    return <ErrorPageWrapper
        icon={<LoadingCircleIconAnimated size={iconSize}/>}
        title={'Willkommen im Online-Unterricht!'}
        content={<div>Der Login-Screen wird geladen...</div>}
    />
};